(function () {
  var api = window.NCFaqAccordion || {};

  function stemWord(word) {
    var replacements = {
      installation: "install",
      installations: "install",
      installed: "install",
      installing: "install",
      installs: "install",
      installer: "install",
      installers: "install",
      product: "product",
      products: "product",
      fireplace: "fireplace",
      fireplaces: "fireplace",
      safety: "safe",
      safely: "safe",
      safer: "safe",
      shipping: "ship",
      shipped: "ship",
      ships: "ship",
      warranty: "warranty",
      warranties: "warranty",
      returns: "return",
      returned: "return",
      returning: "return",
      dimensions: "dimension",
      dimension: "dimension",
      sizing: "size",
      sizes: "size",
      heating: "heat",
      heated: "heat",
      electrical: "electric",
      electricity: "electric"
    };

    if (replacements[word]) return replacements[word];

    var suffixes = ["ation", "tion", "ers", "ing", "ed", "es", "er", "s"];
    var stem = word;

    suffixes.some(function (suffix) {
      if (stem.length > suffix.length + 3 && stem.slice(-suffix.length) === suffix) {
        stem = stem.slice(0, -suffix.length);
        return true;
      }

      return false;
    });

    return stem;
  }

  function getSearchTokens(value) {
    return normalizeText(value)
      .split(" ")
      .filter(Boolean)
      .map(stemWord);
  }

  function normalizeText(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[×]/g, " x ")
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function setItemOpen(root, itemToOpen) {
    root.querySelectorAll("[data-nc-faq-item]").forEach(function (item) {
      var isOpen = item === itemToOpen;
      var trigger = item.querySelector("[data-nc-faq-trigger]");
      var panel = item.querySelector("[data-nc-faq-panel]");

      item.classList.toggle("is-open", isOpen);

      if (trigger) {
        trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }

      if (panel) {
        panel.hidden = !isOpen;
      }
    });
  }

  function closeAll(root) {
    setItemOpen(root, null);
  }

  function buildSearchIndex(item) {
    var question = item.querySelector("[data-nc-faq-question]");
    var answer = item.querySelector("[data-nc-faq-answer]");
    var text = [question ? question.textContent : "", answer ? answer.textContent : ""].join(" ");
    var normalized = normalizeText(text);
    var stems = getSearchTokens(text);

    item.dataset.ncFaqSearchIndex = normalized + " " + stems.join(" ");
  }

  function applySearch(root) {
    var input = root.querySelector("[data-nc-faq-search]");
    var empty = root.querySelector("[data-nc-faq-empty]");
    var query = input ? input.value : "";
    var queryTokens = getSearchTokens(query);
    var hasQuery = queryTokens.length > 0;
    var visibleCount = 0;

    root.querySelectorAll("[data-nc-faq-item]").forEach(function (item) {
      var index = item.dataset.ncFaqSearchIndex || "";
      var isMatch = !hasQuery || queryTokens.every(function (token) {
        return index.indexOf(token) !== -1;
      });

      item.hidden = !isMatch;

      if (isMatch) {
        visibleCount += 1;
      } else if (item.classList.contains("is-open")) {
        setItemOpen(root, null);
      }
    });

    if (empty) {
      empty.hidden = visibleCount !== 0;
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.ncFaqAccordionInitialized === "true") return;

    var input = root.querySelector("[data-nc-faq-search]");

    root.dataset.ncFaqAccordionInitialized = "true";

    root.querySelectorAll("[data-nc-faq-item]").forEach(buildSearchIndex);

    var openItems = root.querySelectorAll("[data-nc-faq-item].is-open");
    if (openItems.length > 1) {
      setItemOpen(root, openItems[0]);
    }

    root.ncFaqAccordionClickHandler = function (event) {
      var trigger = event.target.closest("[data-nc-faq-trigger]");
      if (!trigger || !root.contains(trigger)) return;

      var item = trigger.closest("[data-nc-faq-item]");
      var isOpen = item && item.classList.contains("is-open");

      if (!item) return;

      if (isOpen) {
        closeAll(root);
      } else {
        setItemOpen(root, item);
      }
    };

    root.addEventListener("click", root.ncFaqAccordionClickHandler);

    if (input) {
      root.ncFaqAccordionSearchHandler = function () {
        applySearch(root);
      };

      input.addEventListener("input", root.ncFaqAccordionSearchHandler);
      applySearch(root);
    }
  }

  function resetRoot(root) {
    if (!root) return;

    var input = root.querySelector("[data-nc-faq-search]");

    if (root.ncFaqAccordionClickHandler) {
      root.removeEventListener("click", root.ncFaqAccordionClickHandler);
    }

    if (input && root.ncFaqAccordionSearchHandler) {
      input.removeEventListener("input", root.ncFaqAccordionSearchHandler);
    }

    delete root.ncFaqAccordionClickHandler;
    delete root.ncFaqAccordionSearchHandler;
    delete root.dataset.ncFaqAccordionInitialized;
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-faq-accordion]")
      : [];

    if (scope.matches && scope.matches("[data-nc-faq-accordion]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function resetAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-faq-accordion]")
      : [];

    if (scope.matches && scope.matches("[data-nc-faq-accordion]")) {
      resetRoot(scope);
    }

    roots.forEach(resetRoot);
  }

  api.initAll = initAll;
  api.resetAll = resetAll;
  window.NCFaqAccordion = api;

  if (!window.__ncFaqAccordionEventsBound) {
    window.__ncFaqAccordionEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCFaqAccordion.initAll(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      window.NCFaqAccordion.initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCFaqAccordion.resetAll(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCFaqAccordion.initAll(document);
  }
})();
